import { render, staticRenderFns } from "./TotalToBeReceivedCard.vue?vue&type=template&id=f1f78d7c&scoped=true"
import script from "./TotalToBeReceivedCard.vue?vue&type=script&lang=js"
export * from "./TotalToBeReceivedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f78d7c",
  null
  
)

export default component.exports